import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

export default function PageHero({ overline, title, subtitle, image }) {
  const ref = useRef(null);
  const { scrollY } = useScroll();
  const y = useTransform(scrollY, [0, 600], [0, 120]);
  const scale = useTransform(scrollY, [0, 600], [1, 1.02]);
  return (
    <section ref={ref} className="relative pt-32 pb-20 md:pt-44 md:pb-28 bg-charcoal text-white overflow-hidden">
      {image && (
        <motion.div style={{ y, scale }} className="absolute inset-0 will-change-transform">
          <img src={image} alt="" className="w-full h-full object-cover object-[75%_center] opacity-45" />
        </motion.div>
      )}
      <div className="absolute inset-0 bg-gradient-to-b from-charcoal/65 via-charcoal/70 to-charcoal" />
      {/* Strong top blanket behind navbar for guaranteed legibility */}
      <div className="absolute top-0 left-0 right-0 h-32 md:h-36 bg-gradient-to-b from-charcoal/70 to-transparent pointer-events-none" />
      <div className="grain absolute inset-0" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        {overline && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            className="overline text-stenzia-gold"
          >
            <span className="kbd-line" /> {overline}
          </motion.div>
        )}
        <motion.h1
  className="mt-6 font-display font-light text-5xl md:text-6xl lg:text-7xl tracking-tighter leading-[1.02] max-w-4xl"
  initial="hidden"
  animate="visible"
  variants={{
  visible: {
    transition: {
      delayChildren: 0.15,
      staggerChildren: 0.08,
    },
  },
}}
>
 {(title || "").trim().split(/\s+/).map((word, index) => (
    <motion.span
      key={index}
      variants={{
        hidden: {
          opacity: 0,
          y: 40,
        },
        visible: {
          opacity: 1,
          y: 0,
          transition: {
            duration: 0.8,
            ease: [0.22, 0.61, 0.36, 1],
          },
        },
      }}
      className="inline-block mr-3"
    >
      {word}
    </motion.span>
  ))}
</motion.h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="mt-6 text-base md:text-lg text-white/70 max-w-2xl leading-relaxed"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
}
